import { AutoComplete, ConfigProvider, Tag } from 'antd';

/**
 * @typedef {Object} CountProps
 * @property {boolean} show
 * @property {number} max
 * @property {(value: string) => number} [strategy]
 * @property {(value: string, opts: {max: number}) => string} [exceedFormatter]
 */

/**
 * @typedef {Object} CustomAutoCompleteProps
 * @property {import('antd/es/select/style/token.d.ts').ComponentToken} selectThemeToken
 * @property {CountProps} count
 */

/**
 * @param {CustomAutoCompleteProps & import('antd/es/auto-complete').AutoCompleteProps} props
 */
export const CustomAutoComplete = ({ selectThemeToken, count, ...props }) => {
    return (
        <ConfigProvider theme={{ components: { Select: selectThemeToken } }}>
            <AutoComplete
                {...props}
                suffixIcon={count.show && (
                    <Tag style={{ minHeight: 24, paddingInline: 8, fontSize: 12, lineHeight: '24px' }}>
                        {count.strategy(props.value || '') || (props.value ? props.value?.length : 0)} / {count.max}
                    </Tag>
                )}

                onChange={(value) => {
                    let newValue = value;
                    if (count.show && value.length > count.max) {
                        if (count.exceedFormatter) {
                            newValue = count.exceedFormatter(value, { max: count.max });
                        } else {
                            newValue = value.slice(0, count.max);
                        }
                    }
                    props.onChange(newValue);
                }}
            />
        </ConfigProvider>
    );
}